import { createCmdKey as S, getPalette as E, ThemeIcon as x, commandsCtx as k, ThemeSize as L, ThemeColor as $, ThemeBorder as y, ThemeShadow as I, ThemeScrollbar as v, ThemeFont as w, rootCtx as M, createCmd as A } from "@milkdown/core";
import { setBlockType as H, wrapIn as f, selectParentNode as P } from "@milkdown/prose/commands";
import { TextSelection as _, PluginKey as B, Plugin as z } from "@milkdown/prose/state";
import { createPlugin as N, AtomList as F } from "@milkdown/utils";
import { undo as R, redo as W } from "@milkdown/prose/history";
import { liftListItem as D, sinkListItem as K } from "@milkdown/prose/schema-list";
import { missingRootElement as O } from "@milkdown/exception";
const g = (e, t) => {
  if (!t)
    return !1;
  const { from: n, $from: s, to: o, empty: r } = e.selection;
  return r ? !!t.isInSet(e.storedMarks || s.marks()) : e.doc.rangeHasMark(n, o, t);
}, T = S("SelectParent"), q = [
  [
    {
      type: "select",
      text: "Heading",
      options: [
        { id: "1", text: "Large Heading" },
        { id: "2", text: "Medium Heading" },
        { id: "3", text: "Small Heading" },
        { id: "0", text: "Plain Text" }
      ],
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.heading;
        if (!n)
          return !0;
        const s = (o) => H(n, { level: o })(t);
        return !(e.state.selection instanceof _) || !(s(1) || s(2) || s(3));
      },
      onSelect: (e) => Number(e) ? ["TurnIntoHeading", Number(e)] : ["TurnIntoText", null]
    }
  ],
  [
    {
      type: "button",
      icon: "undo",
      key: "Undo",
      disabled: (e) => !R(e.state)
    },
    {
      type: "button",
      icon: "redo",
      key: "Redo",
      disabled: (e) => !W(e.state)
    }
  ],
  [
    {
      type: "button",
      icon: "bold",
      key: "ToggleBold",
      active: (e) => g(e.state, e.state.schema.marks.strong),
      disabled: (e) => !e.state.schema.marks.strong
    },
    {
      type: "button",
      icon: "italic",
      key: "ToggleItalic",
      active: (e) => g(e.state, e.state.schema.marks.em),
      disabled: (e) => !e.state.schema.marks.em
    },
    {
      type: "button",
      icon: "strikeThrough",
      key: "ToggleStrikeThrough",
      active: (e) => g(e.state, e.state.schema.marks.strike_through),
      disabled: (e) => !e.state.schema.marks.strike_through
    }
  ],
  [
    {
      type: "button",
      icon: "bulletList",
      key: "WrapInBulletList",
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.bullet_list;
        return n ? !f(n)(t) : !0;
      }
    },
    {
      type: "button",
      icon: "orderedList",
      key: "WrapInOrderedList",
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.ordered_list;
        return n ? !f(n)(t) : !0;
      }
    },
    {
      type: "button",
      icon: "taskList",
      key: "TurnIntoTaskList",
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.task_list_item;
        return n ? !f(n)(t) : !0;
      }
    },
    {
      type: "button",
      icon: "liftList",
      key: "LiftListItem",
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.list_item;
        return n ? !D(n)(t) : !0;
      }
    },
    {
      type: "button",
      icon: "sinkList",
      key: "SinkListItem",
      disabled: (e) => {
        const { state: t } = e, n = t.schema.nodes.list_item;
        return n ? !K(n)(t) : !0;
      }
    }
  ],
  [
    {
      type: "button",
      icon: "link",
      key: "ToggleLink",
      active: (e) => g(e.state, e.state.schema.marks.link)
    },
    {
      type: "button",
      icon: "image",
      key: "InsertImage"
    },
    {
      type: "button",
      icon: "table",
      key: "InsertTable"
    },
    {
      type: "button",
      icon: "code",
      key: "TurnIntoCodeFence"
    }
  ],
  [
    {
      type: "button",
      icon: "quote",
      key: "WrapInBlockquote"
    },
    {
      type: "button",
      icon: "divider",
      key: "InsertHr"
    },
    {
      type: "button",
      icon: "select",
      key: T
    }
  ]
], j = (e, t, n) => {
  const s = document.createElement("button");
  s.setAttribute("type", "button"), e.themeManager.onFlush(() => {
    s.className = "button";
    const r = e.getStyle(({ css: i }) => {
      const a = E(e.themeManager);
      return i`
                border: 0;
                box-sizing: unset;
                width: 2em;
                height: 2em;
                padding: 0.25em;
                margin: 0.5em;
                flex-shrink: 0;
                font-size: 0.875em;

                display: flex;
                justify-content: center;
                align-items: center;

                background-color: ${a("surface")};
                color: ${a("solid")};
                transition: color 0.4s ease-in-out, background-color 0.4s ease-in-out;

                cursor: pointer;

                &.active,
                &:hover {
                    background-color: ${a("secondary", 0.12)};
                    color: ${a("primary")};
                }

                &:disabled {
                    display: none;
                }

                .material-icons-outlined {
                    font-size: 1.8em;
                }
            `;
    });
    r && s.classList.add(r);
  });
  const o = e.themeManager.get(x, t.icon);
  if (o) {
    const { label: r, dom: i } = o;
    r && (s.setAttribute("aria-label", r), s.setAttribute("title", r)), s.appendChild(i);
  } else
    s.setAttribute("aria-label", t.icon), s.setAttribute("title", t.icon), s.textContent = t.icon;
  return s.addEventListener("mousedown", (r) => {
    r.preventDefault(), r.stopPropagation(), n.get(k).call(t.key, t.options);
  }), s;
}, U = (e) => {
  const t = document.createElement("div");
  t.classList.add("divider");
  const { themeManager: n } = e;
  return n.onFlush(() => {
    const s = e.getStyle(({ css: o }) => o`
                flex-shrink: 0;
                width: ${n.get(L, "lineWidth")};
                background-color: ${n.get($, ["line"])};
                margin: 0.75em 1em;
                min-height: 1.5em;
            `);
    s && t.classList.add(s);
  }), t;
}, G = (e, t, n, s) => {
  var m;
  const o = document.createElement("div");
  o.classList.add("menu-selector-wrapper", "fold");
  const r = document.createElement("button");
  r.setAttribute("type", "button"), r.classList.add("menu-selector", "fold"), r.addEventListener("mousedown", (u) => {
    var l;
    u.preventDefault(), u.stopPropagation(), o.classList.toggle("fold"), d.style.left = `${o.getBoundingClientRect().left - (((l = s.dom.parentElement) == null ? void 0 : l.getBoundingClientRect().left) || 0)}px`;
  }), s.dom.addEventListener("click", () => {
    o.classList.add("fold");
  });
  const i = document.createElement("span");
  i.classList.add("menu-selector-value"), i.textContent = t.text;
  const a = (m = e.themeManager.get(x, "downArrow")) == null ? void 0 : m.dom;
  o.appendChild(r), r.appendChild(i), a && (a.setAttribute("aria-hidden", "true"), r.appendChild(a));
  const d = document.createElement("div");
  d.classList.add("menu-selector-list"), t.options.forEach((u) => {
    const l = document.createElement("button");
    l.setAttribute("type", "button"), l.dataset.id = u.id, l.textContent = u.text, l.classList.add("menu-selector-list-item"), d.appendChild(l);
  }), d.addEventListener("mousedown", (u) => {
    const { target: l } = u;
    if (l instanceof HTMLButtonElement && l.dataset.id) {
      const b = t.onSelect(l.dataset.id, s), [p, h] = b;
      typeof p == "string" ? n.get(k).call(p, h) : n.get(k).call(p, h), o.classList.add("fold");
    }
  }), o.appendChild(d);
  const { themeManager: c } = e;
  return c.onFlush(() => {
    const u = e.getStyle(({ css: l }) => {
      const b = (p, h = 1) => c.get($, [p, h]);
      return l`
                flex-shrink: 0;
                font-weight: 500;
                font-size: 0.875em;

                ${c.get(y, "right")}
                ${c.get(y, "left")}

                .menu-selector {
                    border: 0;
                    box-sizing: unset;
                    cursor: pointer;
                    font: inherit;
                    text-align: left;
                    justify-content: space-between;
                    align-items: center;
                    color: ${b("neutral", 0.87)};
                    display: flex;
                    padding: 0.25em;
                    margin: 0.5em;
                    height: 2em;
                    background: ${b("secondary", 0.12)};
                    width: 10.375em;

                    &:disabled {
                        display: none;
                    }
                }

                .menu-selector-value {
                    flex: 1;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .menu-selector-list {
                    width: 11.875em;
                    position: absolute;
                    background: ${b("surface")};
                    ${c.get(y, void 0)}
                    ${c.get(I, void 0)}
                    border-bottom-left-radius: ${c.get(L, "radius")};
                    border-bottom-right-radius: ${c.get(L, "radius")};
                    z-index: 3;
                }

                .menu-selector-list-item {
                    background-color: transparent;
                    border: 0;
                    cursor: pointer;
                    display: block;
                    font: inherit;
                    text-align: left;
                    padding: 0.75em 1em;
                    line-height: 1.5em;
                    width: 100%;
                    color: ${b("neutral", 0.87)};

                    &:hover {
                        background: ${b("secondary", 0.12)};
                        color: ${b("primary")};
                    }
                }

                &.fold {
                    border-color: transparent;

                    .menu-selector {
                        background: unset;
                    }

                    .menu-selector-list {
                        display: none;
                    }
                }
            `;
    });
    u && o.classList.add(u);
  }), o;
};
class J {
  constructor(t, n, s, o, r) {
    this.utils = n, this.ctx = s, this.config = t.map((i) => i.map((a) => ({
      ...a,
      $: this.$create(a, r)
    }))).map((i, a) => {
      if (a === t.length - 1)
        return i;
      const d = {
        type: "divider",
        group: i.map((c) => c.$)
      };
      return [...i, { ...d, $: this.$create(d, r) }];
    }).flat(), this.config.forEach((i) => o.appendChild(i.$));
  }
  update(t) {
    this.config.forEach((n) => {
      if (n.type === "button") {
        n.active && (n.active(t) ? n.$.classList.add("active") : n.$.classList.remove("active")), n.disabled && (n.disabled(t) ? n.$.setAttribute("disabled", "true") : n.$.removeAttribute("disabled"));
        return;
      }
      if (n.type === "select" && n.disabled) {
        const s = n.disabled(t), o = n.$.children[0];
        o && (s ? (n.$.classList.add("disabled"), o.setAttribute("disabled", "true")) : (n.$.classList.remove("disabled"), o.removeAttribute("disabled")));
      }
      n.type === "divider" && (n.group.every((o) => o.getAttribute("disabled") || o.classList.contains("disabled")) ? n.$.classList.add("disabled") : n.$.classList.remove("disabled"));
    });
  }
  $create(t, n) {
    const { utils: s, ctx: o } = this;
    switch (t.type) {
      case "button":
        return j(s, t, o);
      case "select":
        return G(s, t, o, n);
      case "divider":
      default:
        return U(s);
    }
  }
}
const Q = ({ milkdownDOM: e, editorRoot: t, menu: n, menuWrapper: s }) => {
  t.appendChild(e), s.remove(), n.remove();
}, X = ({ menu: e, menuWrapper: t, editorRoot: n, milkdownDOM: s }) => {
  t.appendChild(e), n.replaceChild(t, s), t.appendChild(s);
}, Y = (e) => {
  if (!e)
    return document.body;
  if (typeof e == "string") {
    const t = document.querySelector(e);
    return t || document.body;
  }
  return e;
}, Z = (e, t, n, s = X) => {
  const o = document.createElement("div");
  o.classList.add("milkdown-menu-wrapper");
  const r = document.createElement("div");
  r.classList.add("milkdown-menu");
  const i = t.dom, { themeManager: a } = e;
  a.onFlush(() => {
    const l = e.getStyle(() => a.get(v, ["y"]));
    l && i.classList.add(l);
    const b = e.getStyle(({ css: p }) => {
      const h = a.get(y, void 0), C = a.get(v, ["x", "thin"]);
      return p`
                font-family: ${a.get(w, "typography")};
                box-sizing: border-box;
                width: 100%;
                display: flex;
                flex-wrap: nowrap;
                overflow-x: scroll;
                ${h};
                ${C};
                overflow-y: hidden;
                background: ${a.get($, ["surface"])};
                transition: background-color 0.4s ease-in-out;

                -webkit-overflow-scrolling: auto;

                .disabled {
                    display: none;
                }
            `;
    });
    b && b.split(" ").forEach((p) => r.classList.add(p));
  });
  const d = n.get(M), c = Y(d), m = i.parentElement;
  if (!m)
    throw O();
  return s({
    menu: r,
    menuWrapper: o,
    editorDOM: i,
    editorRoot: c,
    milkdownDOM: m
  }), [r, () => {
    Q({
      menu: r,
      menuWrapper: o,
      editorDOM: i,
      editorRoot: c,
      milkdownDOM: m
    });
  }];
}, V = new B("MILKDOWN_MENU"), ee = N((e, t) => {
  const n = t == null ? void 0 : t.domHandler;
  let s = null, o = null, r = null;
  const i = (a, d) => {
    const c = t != null && t.config ? typeof t.config == "function" ? t.config(a) : t.config : q;
    if (!!d.editable) {
      if (!o) {
        const [m, u] = Z(e, d, a, n);
        o = m, s = () => {
          u(), o = null, r = null;
        };
      }
      r || (r = new J(c, e, a, o, d));
    }
  };
  return {
    commands: () => [A(T, () => P)],
    prosePlugins: (a, d) => [new z({
      key: V,
      view: (m) => (i(d, m), m.editable && (r == null || r.update(m)), {
        update: (u) => {
          i(d, m), m.editable ? r == null || r.update(u) : s == null || s();
        },
        destroy: () => {
          s == null || s();
        }
      })
    })]
  };
}), le = F.create([ee()]);
export {
  T as SelectParent,
  q as defaultConfig,
  le as menu,
  V as menuKey,
  ee as menuPlugin
};
//# sourceMappingURL=index.es.js.map
